import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import scss from './ClusterRespondentsValue.module.scss';

const ClusterRespondentsValue = ({ clusterRespondents }) => {
  const { t } = useTranslation('resonance');
  const numberOfRespondents = useSelector((state) => state.resonance.numberOfRespondents);

  if (clusterRespondents === null) {
    return null;
  }

  const roundedClusterRespondents = Math.round(clusterRespondents);

  return (
    <div className={scss.labelRow}>
      <span className={scss.textBold}>{t('numberOfRespondents')}:</span>
      <span className={scss.textDefault}>
        {roundedClusterRespondents} / {numberOfRespondents}
      </span>
    </div>
  );
};

export default ClusterRespondentsValue;
